<template>
  <div class="card card-fluid">
    <div class="card-header">
      <div class="d-flex align-items-center">
        <span class="mr-auto">BPJS Kesehatan</span>
        <div class="btn-job-title">
          <button class="btn btn-success btn-modal" v-b-modal.bpjs-kesehatan tabindex="0"  type="button" data-title="[Request]">
            <span>Add Record</span>
          </button>
        </div>
      </div>
    </div><!-- /.card-header -->
    <div class="card-body">
      <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
        <b-table hover :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover :class="{'hide-scroll': isScrollHide()}">
          <template v-slot:cell(action)="row">
            <a class="btn btn-xs"  @click="detailRow(row.item, row.index, $event.target)" title="Detail">
              <em class="fa fa-search"></em>
            </a>
            <a class="btn btn-xs"  @click="editRow(row.item, row.index, $event.target)" title="Edit">
              <em class="fa fa-pencil-alt"></em>
            </a>
            <a class="btn btn-xs"  @click="deleteRow(row.item, row.index, $event.target)" title="Delete">
              <em class="fa fa-trash"></em>
            </a>
          </template>
        </b-table>
        <div class="row align-items-center">
          <div class="col-sm-12 col-md-5">
            <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
          </div>
          <div class="col-sm-12 col-md-7 d-flex justify-content-end">
            <div class="dataTables_paginate paging_simple_numbers">
              <b-pagination v-model="currentPage" v-on:click="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <bpjs-kesehatan-input ref="mdl" :data="data"></bpjs-kesehatan-input>
    <bpjs-kesehatan-detail-form ref="mdl-det" :data="data"></bpjs-kesehatan-detail-form>
  </div>
</template>

<script>

import {BTable, BPagination, VBModal} from "bootstrap-vue"
import {mapGetters} from "vuex";
import BpjsKesehatanInput from "@/components/pages/bpjs-kesehatan/BpjsKesehatanInput";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import BpjsKesehatanDetailForm from "./BpjsKesehatanDetailForm";
export default {
  name: "BpjsKesehatanDetail",
  components:{
    BpjsKesehatanDetailForm,
    BpjsKesehatanInput,
    BTable,
    BPagination
  },
  directives:{
    'b-modal':VBModal
  },
  data(){
    return {
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'name', sortable: true},
        { key: 'number', sortable: true },
        { key: 'registered_date', sortable: true },
        { key: 'last_modified', sortable: true },
      ],
      rows:0,
      perPage:5,
      currentPage:1,
      data:null
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },
  watch:{
    currentPage:function (){
      this.getData()
    }
  },
  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    getData(){
      this.items = []
      let payload = {
        page : this.currentPage,
        limit: this.perPage,
        emp_id: this.$store.getters.empId
      }
      AxiosCall.Get(payload, urlApi.bpjs_kesehatan.index).then(res=>{
        if (res.success){
          let no = (this.currentPage - 1) * this.perPage +1
          for(let data of res.atributes){
            data.no = no++
            this.items.push(data)
          }
          this.rows = res.total
        }else {
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    editRow(item){
      this.data = item
      this.$refs.mdl.$refs.modal.show()
    },
    detailRow(item){
      this.data = item
      this.$refs["mdl-det"].$refs.modal.show()
    },
    deleteRow(item){
      this.data = item
      this.$refs["modal-delete"].show()
    },
    deleteItem(){
      AxiosCall.Delete(urlApi.passport.delete+"/"+this.data.id).then(res=>{
        console.log(res)
        if (res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs["modal-delete"].hide()
        }else{
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        console.log(JSON.stringify(e))
        this.errorMessage(e.response.data.message)
      })
    },
    resetModal(){
      this.data = null
    }
  },
  created() {
    this.getData()
  }
}
</script>